import { render, staticRenderFns } from "./TheTagChatModal.vue?vue&type=template&id=4397bc21"
import script from "./TheTagChatModal.vue?vue&type=script&lang=js"
export * from "./TheTagChatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports